import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Size and scale",
  "description": "",
  "published": "2007-04-04T00:00:00.000Z",
  "redirect_from": ["/blog/size-and-scale/swizec/243"],
  "categories": "intrigues, linkages",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A coworker gave me the link to `}<a parentName="p" {...{
        "href": "http://typetester.maratz.com/"
      }}>{`typetester`}</a>{` yesterday, a web based application every webdesigner should have in their toolbox. It basically lets you test and try different fonts at different sizes, background and colours, plus, on top of it all, it featuers a rather good looking design - never has a tool looked this good.`}</p>
    <p>{`Through `}<a parentName="p" {...{
        "href": "http://www.commissionedcomic.com/"
      }}>{`commissioned`}</a>{`, or rather their blog, I discovered `}<a parentName="p" {...{
        "href": "http://www.nikon.co.jp/main/eng/feelnikon/discovery/universcale/index_f.htm"
      }}>{`this pretty thing`}</a>{`. It puts everything from the smalelst to the largest to scale and is rather very intriguing. The developer should give some more thought to the users beacuse the scrolling is a tad slow and then when it pops up interesting stuff it doesn't stop scrolling so you're bound to miss something.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      